export function formatDate(d) {
var formatted = `
${d.getFullYear()}/
${d.getMonth()+1}/
${d.getDate()}
`.replace(/\n|\r/g, '');
 
  console.log(formatted);
  return formatted;
}

export function getRadioValue(name) {
  const ele = document.getElementsByName(name);
  for(let i = 0; i < ele.length; i++) {
    if(ele[i].checked)
      return ele[i].value;
  }
  return null;
}

export function checkYMD(y,m,d) {
    console.log(y.length != 4);
    console.log(y.match(/[^0-9]/) == null);
    const r = (y.length == 4 && y.match(/[^0-9]/) == null) && (m.length == 2 && m.match(/[^0-9]/) == null) && (d.length == 2 && d.match(/[^0-9]/) == null);
    return r;
}

export function formatDateG (date, format) {
  format = format.replace(/yyyy/g, date.getFullYear());
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
  format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
  format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
  return format;
};

export function formatJpDateFromString(dateStr) {
  if (!dateStr) return "";
  const arr = dateStr.split('/');
  if (dateStr.length < 1 || arr.length != 3) return "";
  return `${parseInt(arr[0])}年${arr[1]}月${arr[2]}日`;
}

export function getAnnualFeeStatusName(state) {
  if (state == null) return '';
  if (1 == state)
    return '入金済';
  else
    return '未入金';
};

export function validateSimpleDateFormat(d) {
  const arr = d.split('/');
  if (arr.length != 3) return '2021/08/20 の形式で入力してください。';
  if (arr[0].match(/[^0-9]/) != null || arr[1].match(/[^0-9]/) != null || arr[2].match(/[^0-9]/) != null)
    return '数字は半角で入力してください。';
  if (arr[0].length != 4) return '西暦は4桁で入力してください。';
  if (arr[1].length != 2 || arr[2].length != 2) return '月、日は2桁で入力してください。';
  return '';
}

